import * as React from 'react';

import { ONLY_NON_BILLABLE } from '@acceligentllc/shared/constants/productionData';

import EmptyCell from 'af-components/Table/Cells/EmptyCell';

export function noRevenueCellValue(hasOnlyNonBillableWork: boolean, revenueSubtractions: number) {
	if (hasOnlyNonBillableWork) {
		return revenueSubtractions ? `${ONLY_NON_BILLABLE} - $${revenueSubtractions}` : ONLY_NON_BILLABLE;
	}
	return <EmptyCell />;
}
